import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-703bd1aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pre-trip-complete-day-modal" }
const _hoisted_2 = {
  key: 0,
  class: "pre-trip-complete-day-modal__state"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-500" }, "При получении списка предрейсов произошла ошибка", -1))
const _hoisted_4 = {
  key: 0,
  class: "pre-trip-complete-day-modal__completed"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "100",
  height: "100",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    opacity: "0.9",
    "clip-path": "url(#clip0_3847_3369)"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M97.1391 13.6714C95.668 12.1978 93.2811 12.1952 91.81 13.6652L46.5965 58.7593L30.2836 41.0419C28.8741 39.5118 26.4909 39.4126 24.9583 40.822C23.4268 42.2316 23.3288 44.6159 24.7383 46.1474L43.7083 66.7491C44.403 67.5042 45.3752 67.9427 46.4004 67.964C46.428 67.9652 46.4545 67.9652 46.4809 67.9652C47.4772 67.9652 48.4356 67.5695 49.1416 66.8659L97.1317 19.0017C98.6065 17.532 98.609 15.145 97.1391 13.6714Z",
      fill: "#F1F5F9"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M96.2311 46.2311C94.1494 46.2311 92.4623 47.9182 92.4623 50C92.4623 73.4146 73.4146 92.4623 50 92.4623C26.5867 92.4623 7.53769 73.4146 7.53769 50C7.53769 26.5867 26.5867 7.53769 50 7.53769C52.0816 7.53769 53.7689 5.85059 53.7689 3.76895C53.7689 1.68711 52.0816 0 50 0C22.4297 0 0 22.4297 0 50C0 77.5691 22.4297 100 50 100C77.5691 100 100 77.5691 100 50C100 47.9184 98.3129 46.2311 96.2311 46.2311Z",
      fill: "#F1F5F9"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_3847_3369" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "100",
        height: "100",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "font-semibold mt-8",
  style: {"font-size":"30px"}
}, "Спасибо!", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-5" }, "Все рейсы перенесены и прокомментированы.", -1))
const _hoisted_8 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_9 = { class: "form__container mt-4" }
const _hoisted_10 = { class: "pre-trip-complete-day-modal__actions" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["loading", "disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Внимание!", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "По некоторым предрейсам не созданы рейсы.", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Перенесите их на другую дату и внесите комментарий с причиной или создайте рейсы перед завершением дня:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_group_by_date = _resolveComponent("group-by-date")!
  const _component_pretrips_group = _resolveComponent("pretrips-group")!
  const _component_the_modal = _resolveComponent("the-modal")!

  return (_openBlock(), _createBlock(_component_the_modal, {
    class: "extra-large",
    title: "Завершение дня",
    "without-footer": "",
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.pretrips_state.is_loading || _ctx.pretrips_state.is_failed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.pretrips_state.is_loading)
                ? (_openBlock(), _createBlock(_component_loader, {
                    key: 0,
                    class: "primary"
                  }))
                : (_ctx.pretrips_state.is_failed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_3,
                      _createVNode(_component_the_button, {
                        class: "primary small mt-2",
                        onClick: _ctx.loadPretrips
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Обновить")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.state.is_can_complete || _ctx.pretrips_state.groups.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7,
                    _createElementVNode("button", {
                      class: "pre-trip-complete-day-modal__button button--primary mt-8",
                      style: {"min-width":"100px"},
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
                    }, "OK")
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.update_pretrip_state.is_opened)
                      ? (_openBlock(), _createElementBlock("form", {
                          key: 0,
                          class: "pre-trip-complete-day-modal__form",
                          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onUpdatePretripSubmit && _ctx.onUpdatePretripSubmit(...args)), ["prevent"]))
                        }, [
                          (_ctx.update_pretrip_state.pretrip)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.update_pretrip_state.pretrip.direction.fromCity.name) + " - " + _toDisplayString(_ctx.update_pretrip_state.pretrip.direction.whereCity.name), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_new_select, {
                              placeholder: "Укажите причину",
                              value: _ctx.update_pretrip_state.reasonId,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.update_pretrip_state.reasonId) = $event)),
                              options: _ctx.reasons_state.list,
                              loading: _ctx.reasons_state.is_loading,
                              failed: _ctx.reasons_state.is_failed,
                              disabled: _ctx.reasons_state.is_loading || _ctx.update_pretrip_state.is_loading,
                              searchable: false,
                              "is-invalid": _ctx.update_pretrip_form$.reasonId.$error,
                              "validation-errors": _ctx.update_pretrip_form$.reasonId.$errors,
                              onChange: _ctx.onReasonChange
                            }, null, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors", "onChange"]),
                            _createVNode(_component_new_input, {
                              type: "date",
                              value: _ctx.update_pretrip_state.date,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.update_pretrip_state.date) = $event)),
                              placeholder: "Перенос на день",
                              disabled: _ctx.update_pretrip_state.is_loading,
                              "is-invalid": _ctx.update_pretrip_form$.date.$error,
                              "validation-errors": _ctx.update_pretrip_form$.date.$errors,
                              onChange: _ctx.onDateChange
                            }, null, 8, ["value", "disabled", "is-invalid", "validation-errors", "onChange"]),
                            (_ctx.update_pretrip_state.reasonId === _ctx.ISSUE_BY_LOGIST_REASON_ID || _ctx.update_pretrip_state.reasonId === _ctx.ISSUE_BY_WAREHOUSE_REASON_ID)
                              ? (_openBlock(), _createBlock(_component_new_input, {
                                  key: 0,
                                  placeholder: "Комментарий логиста",
                                  value: _ctx.update_pretrip_state.comment,
                                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.update_pretrip_state.comment) = $event)),
                                  disabled: _ctx.update_pretrip_state.is_loading,
                                  "is-invalid": _ctx.update_pretrip_form$.comment.$error,
                                  "validation-errors": _ctx.update_pretrip_form$.comment.$errors
                                }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]))
                              : _createCommentVNode("", true),
                            (_ctx.update_pretrip_state.reasonId === _ctx.EARLY_SEND_REASON_ID)
                              ? (_openBlock(), _createBlock(_component_new_select, {
                                  key: 1,
                                  placeholder: "Укажите рейс",
                                  label: "tripNumber",
                                  value: _ctx.update_pretrip_state.tripId,
                                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.update_pretrip_state.tripId) = $event)),
                                  options: _ctx.trips_state.list,
                                  loading: _ctx.trips_state.is_loading,
                                  failed: _ctx.trips_state.is_failed,
                                  disabled: _ctx.trips_state.is_loading || _ctx.trips_state.is_loading,
                                  searchable: false,
                                  "is-invalid": _ctx.update_pretrip_form$.tripId.$error,
                                  "validation-errors": _ctx.update_pretrip_form$.tripId.$errors
                                }, {
                                  "selected-option": _withCtx(({ option }) => [
                                    _createTextVNode(_toDisplayString(option.tripNumber) + " (" + _toDisplayString(option.fromCity.name) + " - " + _toDisplayString(option.toCity.name) + ") ", 1)
                                  ]),
                                  option: _withCtx(({ option }) => [
                                    _createTextVNode(_toDisplayString(option.tripNumber) + " (" + _toDisplayString(option.fromCity.name) + " - " + _toDisplayString(option.toCity.name) + ") ", 1)
                                  ]),
                                  _: 1
                                }, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "pre-trip-complete-day-modal__button",
                              disabled: _ctx.update_pretrip_state.is_loading,
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onUpdatePretripCancel && _ctx.onUpdatePretripCancel(...args)))
                            }, " Отмена ", 8, _hoisted_11),
                            _createElementVNode("button", {
                              type: "submit",
                              class: "pre-trip-complete-day-modal__button button--primary",
                              loading: _ctx.update_pretrip_state.is_loading,
                              disabled: _ctx.update_pretrip_state.is_loading
                            }, [
                              (_ctx.update_pretrip_state.is_loading)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode("Загрузка...")
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode("Подтвердить")
                                  ], 64))
                            ], 8, _hoisted_12)
                          ])
                        ], 32))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_13,
                          _hoisted_14,
                          _hoisted_15,
                          _createVNode(_component_pretrips_group, { class: "mt-4" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pretrips_state.groups, (group, i) => {
                                return (_openBlock(), _createBlock(_component_group_by_date, {
                                  key: `group-by-date-${i}`,
                                  group: group,
                                  onUpdate: _ctx.onUpdatePretrip
                                }, null, 8, ["group", "onUpdate"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ], 64))
                  ], 64))
            ], 64))
      ])
    ]),
    _: 1
  }, 8, ["onCancel"]))
}